import { ConcreteEncodable } from "./ConcreteEncodable";

import { CurrencyImplEncoder } from "../../encoder/CurrencyImplEncoder";

import * as CubiqTS from "../../index";
import { Currency } from "../Currency";

export class CurrencyImpl extends ConcreteEncodable implements Currency {
  public static enType: string = "com.bcdfx.model.CurrencyImpl";

  /*FID=1*/
  public calendarId: CubiqTS.Long | null = null;
  /*FID=2*/
  public currencyNm: string;
  /*FID=3*/
  public deletedFg: boolean;
  /*FID=4*/
  public id: string;
  /*FID=5*/
  public minorUnitsQty: CubiqTS.Long | null = null;
  /*FID=6*/
  public ndfEnabledFg: boolean;
  /*FID=7*/
  public ordersEnabledFg: boolean;
  /*FID=8*/
  public positionUnitId: CubiqTS.PositionUnit;
  /*FID=9*/
  public stamp: CubiqTS.Long | null = null;
  /*FID=10*/
  public straightThroughProcessingFg: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = CurrencyImplEncoder.Instance;
    this.setEncodableType(CurrencyImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "CurrencyImpl[" +
      "calendarId=" +
      this.calendarId +
      "currencyNm=" +
      this.currencyNm +
      "deletedFg=" +
      this.deletedFg +
      "id=" +
      this.id +
      "minorUnitsQty=" +
      this.minorUnitsQty +
      "ndfEnabledFg=" +
      this.ndfEnabledFg +
      "ordersEnabledFg=" +
      this.ordersEnabledFg +
      "positionUnitId=" +
      this.positionUnitId +
      "stamp=" +
      this.stamp +
      "straightThroughProcessingFg=" +
      this.straightThroughProcessingFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
